// extracted by mini-css-extract-plugin
export default {"root":"NewPromotionCard_root__W63bQ","checked":"NewPromotionCard_checked__NL5jm"};